import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { ApiVisa, ApiResponseModel } from '../shared';
import { Observable } from 'rxjs';

// /core2/tnt/dm/app-login-subject/permitted-users/backoffice-ep

@Injectable({
  providedIn: 'root'
})
export class PermittedUsersClientSidePermissionService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-login-subject/permitted-users/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app-login-subject/permitted-users/backoffice-ep';
    this.httpClient = http;
  }

  getPermittedUsers(permCode: string, appletGuid: string, apiVisa:ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?clientSideDfn=' + permCode + '&appletGuid=' + appletGuid;
    return this.httpClient.get<ApiResponseModel<any>>(url, this.getHttpHeader(apiVisa));
  }
}


